import { render, staticRenderFns } from "./blockCalendarSettings.vue?vue&type=template&id=0ab3c57d&scoped=true&"
import script from "./blockCalendarSettings.vue?vue&type=script&lang=js&"
export * from "./blockCalendarSettings.vue?vue&type=script&lang=js&"
import style0 from "./blockCalendarSettings.vue?vue&type=style&index=0&id=0ab3c57d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab3c57d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
